(() => {
  if (customElements.get('fatt-filter-grid')) return;
  class FattFilterGrid extends HTMLElement {
    async connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.form = this.querySelector('form');
      this.grid = this.querySelector('[data-grid]');
      this.status = this.querySelector('[data-status]');
      this.form.hidden = false;
      this.querySelector('.fatt-shop__toolbar').hidden = false;
      this.items = [];
      try {
        this.readItems(this);
        let next = this.dataset.next;
        const visited = new Set();
        while (next) {
          const url = new URL(next, location.href);
          url.searchParams.set('section_id', this.dataset.section);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          if (visited.has(url.href)) throw new Error('Repeated catalog page');
          visited.add(url.href);
          const response = await fetch(url);
          if (!response.ok) throw new Error('Catalog unavailable');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const root = page.querySelector('fatt-filter-grid');
          if (!root) throw new Error('Catalog missing');
          this.readItems(root);
          next = root.dataset.next;
        }
        this.makeOptions();
        this.querySelector('[data-filter-fields]').disabled = false;
        this.querySelector('[data-pagination]').hidden = true;
        this.restore();
        this.form.addEventListener('submit', event => event.preventDefault());
        this.form.addEventListener('input', () => this.apply(true));
        this.form.addEventListener('reset', () => queueMicrotask(() => this.apply(true)));
        this.querySelector('[data-sort]').addEventListener('change', () => this.apply(true));
        this.onPopState = () => { this.restore(); this.apply(false); };
        window.addEventListener('popstate', this.onPopState);
        this.apply(false);
      } catch (error) {
        this.status.hidden = true;
        this.querySelector('[data-error]').hidden = false;
        this.querySelector('[data-sort]').disabled = true;
        console.error('FATT catalog filters:', error);
      }
    }
    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
    }
    readItems(root) {
      root.querySelectorAll('[data-product]').forEach(node => {
        const data = JSON.parse(node.dataset.product);
        if (this.items.some(item => item.data.id === data.id)) return;
        const item = { node, data, index: this.items.length };
        item.sizeIndex = data.options.findIndex(name => /^sizes?$/i.test(name));
        item.colorIndex = data.options.findIndex(name => /^colou?rs?$/i.test(name));
        const colorTitle = data.title.includes('—') ? data.title.split('—').slice(1).join('—') : data.title;
        const designColors = colorTitle.match(/\b(?:Powder Blue|Royal Blue|Light Blue|Midnight Green|Action Green|Cardinal|Burgundy|Pewter|Coral|Purple|Pink|Teal|Aqua|Navy|Royal|Silver|Gold|White|Black|Red|Green|Brown|Orange|Blue)\b/g) || [];
        data.variants.forEach(variant => {
          const garmentColor = variant.options[item.colorIndex];
          variant.colors = [...new Set([...designColors, ...(garmentColor && !/stitching|collar/i.test(garmentColor) ? [garmentColor] : [])])];
        });
        this.items.push(item);
        if (root !== this) this.grid.append(node);
      });
    }
    makeOptions() {
      const options = { type: new Set(), size: new Set(), color: new Set(), material: new Set() };
      this.items.forEach(({ data, sizeIndex, colorIndex }) => {
        if (data.type) options.type.add(data.type);
        (data.materials || []).filter(Boolean).forEach(value => options.material.add(value));
        data.variants.forEach(variant => {
          if (sizeIndex >= 0) options.size.add(variant.options[sizeIndex]);
          variant.colors.forEach(color => options.color.add(color));
        });
      });
      const sizes = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', 'XXL', '3XL', '4XL', '5XL', '6XL'];
      Object.entries(options).forEach(([name, values]) => {
        const container = this.querySelector(`[data-options="${name}"]`);
        container.classList.add('fatt-shop__checks');
        container.closest('details').hidden = values.size === 0;
        [...values].sort((a, b) => {
          const ai = sizes.indexOf(a), bi = sizes.indexOf(b);
          if (name === 'size' && (ai >= 0 || bi >= 0)) return (ai < 0 ? 100 : ai) - (bi < 0 ? 100 : bi);
          return a.localeCompare(b, undefined, { numeric: true });
        }).forEach(value => {
          const label = document.createElement('label');
          const input = document.createElement('input');
          input.type = 'checkbox'; input.name = name; input.value = value;
          label.append(input, document.createTextNode(value));
          container.append(label);
        });
      });
    }
    restore() {
      const params = new URL(location.href).searchParams;
      this.form.querySelectorAll('input[type=checkbox]').forEach(input => {
        input.checked = params.getAll(`fatt_${input.name}`).includes(input.value);
      });
      ['min', 'max'].forEach(name => { this.form.elements[name].value = params.get(`fatt_${name}`) || ''; });
      this.querySelector('[data-sort]').value = params.get('fatt_sort') || 'featured';
    }
    apply(updateHistory) {
      const state = new FormData(this.form);
      const types = state.getAll('type'), sizes = state.getAll('size'), colors = state.getAll('color');
      const availability = state.getAll('availability');
      const materials = state.getAll('material');
      const min = state.get('min') === '' ? 0 : Math.max(0, Number(state.get('min')) * 100);
      const max = state.get('max') === '' ? Infinity : Number(state.get('max')) * 100;
      let count = 0;
      const matched = this.items.map(item => {
        const variants = item.data.variants.filter(variant =>
          (!sizes.length || sizes.includes(variant.options[item.sizeIndex])) &&
          (!colors.length || colors.some(color => variant.colors.includes(color))) &&
          (!availability.length || availability.includes(variant.available ? 'available' : 'unavailable')) &&
          variant.price >= min && variant.price <= max
        );
        const visible = (!types.length || types.includes(item.data.type)) && (!materials.length || materials.some(value => (item.data.materials || []).includes(value))) && variants.length > 0;
        item.node.hidden = !visible;
        if (visible) count++;
        const variant = variants.find(v => v.available) || variants[0];
        const optionFiltered = sizes.length || colors.length || availability.length || min || max !== Infinity;
        item.node.querySelectorAll('a').forEach(link => {
          const url = new URL(link.href, location.href);
          if (url.pathname !== item.data.url) return;
          if (variant && optionFiltered) url.searchParams.set('variant', variant.id);
          else url.searchParams.delete('variant');
          link.href = url.href;
        });
        return { ...item, price: variants.length ? Math.min(...variants.map(v => v.price)) : Infinity };
      });
      const sort = this.querySelector('[data-sort]').value;
      matched.sort((a, b) => {
        if (sort === 'price-low') return a.price - b.price;
        if (sort === 'price-high') return b.price - a.price;
        if (sort === 'newest') return b.data.date - a.data.date;
        if (sort === 'title') return a.data.title.localeCompare(b.data.title);
        return a.index - b.index;
      });
      matched.forEach(item => this.grid.append(item.node));
      this.status.textContent = this.querySelector('[data-count-template]').textContent.replace('[count]', count).replace('[total]', this.items.length);
      this.querySelector('[data-empty]').hidden = count !== 0;
      this.renderChips();
      if (updateHistory) {
        const url = new URL(location.href);
        [...url.searchParams.keys()].filter(key => key.startsWith('fatt_')).forEach(key => url.searchParams.delete(key));
        for (const [name, value] of state.entries()) if (value !== '') url.searchParams.append(`fatt_${name}`, value);
        if (sort !== 'featured') url.searchParams.set('fatt_sort', sort);
        if (url.href !== location.href) history.pushState({}, '', url);
      }
    }
    renderChips() {
      const holder = this.querySelector('[data-selected]');
      holder.replaceChildren();
      this.form.querySelectorAll('input').forEach(input => {
        if (input.type === 'checkbox' ? !input.checked : input.value === '') return;
        const button = document.createElement('button');
        button.type = 'button';
        const text = input.type === 'checkbox' ? input.closest('label').textContent.trim() : `${input.closest('label').firstChild.textContent.trim()}: ${input.value}`;
        button.textContent = `${text} ×`;
        button.setAttribute('aria-label', this.querySelector('[data-remove-template]').textContent.replace('[value]', text));
        button.addEventListener('click', () => {
          if (input.type === 'checkbox') input.checked = false;
          else input.value = '';
          this.apply(true);
          input.focus();
        });
        holder.append(button);
      });
      holder.hidden = !holder.childElementCount;
    }
  }
  customElements.define('fatt-filter-grid', FattFilterGrid);
})();

